"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelevantExpertMatcherEnum = exports.UnableToCancelClosedSessionError = exports.SessionNotFoundError = exports.BadRequestError = exports.SessionStatus = exports.ConflictStatus = exports.SessionType = void 0;
var SessionType;
(function (SessionType) {
    SessionType["Task"] = "Task";
    SessionType["Remote"] = "Remote";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var ConflictStatus;
(function (ConflictStatus) {
    ConflictStatus["resolved"] = "resolved";
    ConflictStatus["pending"] = "pending";
})(ConflictStatus = exports.ConflictStatus || (exports.ConflictStatus = {}));
var SessionStatus;
(function (SessionStatus) {
    SessionStatus["Pending"] = "pending";
    SessionStatus["Unassigned"] = "unassigned";
    SessionStatus["Assigned"] = "assigned";
    SessionStatus["Resolved"] = "resolved";
    SessionStatus["Cancelled"] = "cancelled";
})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
class BadRequestError extends Error {
    constructor(message, fields) {
        super(message);
        this.status = 400;
        this.type = 'BadRequest';
        this.message = '';
        this.message = message;
        this.fields = fields;
    }
}
exports.BadRequestError = BadRequestError;
class SessionNotFoundError extends Error {
    constructor(fields) {
        super('session not found');
        this.status = 404;
        this.type = 'SessionNotFound';
        this.fields = fields;
    }
}
exports.SessionNotFoundError = SessionNotFoundError;
class UnableToCancelClosedSessionError extends Error {
    constructor(fields = {}) {
        super('Unable to Cancel this closed session');
        this.status = 500;
        this.type = 'UnableToCancelClosedSession';
        this.fields = {};
        this.fields = fields;
    }
}
exports.UnableToCancelClosedSessionError = UnableToCancelClosedSessionError;
var RelevantExpertMatcherEnum;
(function (RelevantExpertMatcherEnum) {
    RelevantExpertMatcherEnum["Default"] = "default";
    RelevantExpertMatcherEnum["Location"] = "location";
})(RelevantExpertMatcherEnum = exports.RelevantExpertMatcherEnum || (exports.RelevantExpertMatcherEnum = {}));
